/**
 * Load a component and instantiate it for each matching element in the DOM.
 *
 * @param {any} component
 * @param {string} selector
 */
export async function loadComponent(component, selector) {
  const matches = document.querySelectorAll(selector);

  if (matches.length) {
    matches.forEach((match) => {
      new component(match);
    });
  }
}

/**
 * Lazy load a component when the selector is found in the DOM.
 *
 * @param {Function} importer
 * @param {string} selector
 */
export async function lazyLoadComponent(importer, selector) {
  const matches = document.querySelectorAll(selector);

  if (matches.length) {
    const mod = await importer();
    loadComponent(mod.default, selector);
  }
}

export async function lazyLoadComponentOnce(importer, selector) {
  const match = document.querySelector(selector);

  if (match) {
    const mod = await importer();
    new mod.default(match);
  }
}
